<template>
  <div class="ov-page">
    <!-- ===== EN-TÊTE ===== -->
    <div class="dag-head">
      <div>
        <div class="dag-head__date">{{ currentDate }}</div>
        <h1 class="dag-head__title">Bienvenue, {{ $store.state.userAuthentified.prenoms || $store.state.userAuthentified.nom }}</h1>
        <div class="dag-head__meta">
          <span v-if="$store.state.userAuthentified.gareDesignation" class="ov-badge ov-badge--navy ov-badge--plain">
            {{ $store.state.userAuthentified.gareDesignation }}
          </span>
          <span v-if="$store.state.userAuthentified.lastConnection">
            Dernière connexion : {{ $store.state.userAuthentified.lastConnection }}
          </span>
        </div>
      </div>
    </div>

    <!-- ===== CAISSE ===== -->
    <section class="dag-section">
      <div class="dag-section__head">
        <h2 class="dag-section__title">Caisse de la gare</h2>
        <span class="ov-badge ov-badge--success">Aujourd'hui</span>
      </div>

      <div class="ov-kpis">
        <div class="ov-kpi ov-kpi--primary">
          <div class="ov-kpi__label">Solde disponible</div>
          <div class="ov-kpi__value">{{ amount(caisse('fondsJour', 'montantDisponible')) }}<span>FCFA</span></div>
        </div>
        <div class="ov-kpi">
          <div class="ov-kpi__label">Total des crédits</div>
          <div class="ov-kpi__value">{{ amount(caisse('fondsJour', 'montantCredit')) }}<span>FCFA</span></div>
        </div>
        <div class="ov-kpi">
          <div class="ov-kpi__label">Total des débits</div>
          <div class="ov-kpi__value">{{ amount(caisse('fondsJour', 'montantDebit')) }}<span>FCFA</span></div>
        </div>
      </div>

      <div class="ov-card">
        <div class="ov-card__head">
          <div>
            <div class="ov-card__title">Comparatif</div>
            <div class="ov-card__sub">Montants en FCFA</div>
          </div>
        </div>
        <div class="dag-table-wrap">
          <table class="dag-table">
            <thead>
              <tr>
                <th>Période</th>
                <th class="dag-num">Crédits</th>
                <th class="dag-num">Débits</th>
                <th class="dag-num">Solde disponible</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in caisseRows" :key="row.key" :class="{ 'dag-table__current': row.key === 'fondsJour' }">
                <td>{{ row.label }}</td>
                <td class="dag-num">{{ amount(caisse(row.key, 'montantCredit')) }}</td>
                <td class="dag-num">{{ amount(caisse(row.key, 'montantDebit')) }}</td>
                <td class="dag-num dag-strong">{{ amount(caisse(row.key, 'montantDisponible')) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>

    <!-- ===== RÉSERVATIONS : FILTRE ===== -->
    <section class="dag-section">
      <div class="dag-section__head dag-section__head--filters">
        <h2 class="dag-section__title">Réservations de la gare</h2>
        <div class="dag-filters">
          <select v-model="dateSelected" class="ov-select" aria-label="Période">
            <option :value="null" disabled>Filtrer par date</option>
            <option v-for="(item, index) in dateFilterList" :key="index" :value="item.title">{{ item.title }}</option>
          </select>
          <template v-if="dateSelected === 'Periodique'">
            <input v-model="dateDebut" type="date" class="ov-input" aria-label="Date de début" title="Date de début" />
            <input v-model="dateFin" type="date" class="ov-input" aria-label="Date de fin" title="Date de fin" />
          </template>
          <input
            v-if="dateSelected === 'À une date précise'"
            v-model="datePrecise"
            type="date"
            class="ov-input"
            aria-label="Date précise"
            title="Date précise"
          />
          <button type="button" class="ov-btn ov-btn--primary" :disabled="!canApplyFilter || filtering" @click="applyFilterReservation">
            <v-progress-circular v-if="filtering" indeterminate size="16" width="2"></v-progress-circular>
            <v-icon v-else small>mdi-magnify</v-icon>
            Appliquer
          </button>
        </div>
      </div>

      <div v-if="isFilterApply" class="dag-block">
        <div class="dag-block__head">
          <h3 class="dag-block__title">Période filtrée</h3>
          <span class="ov-badge ov-badge--navy ov-badge--plain">{{ filterLabel }}</span>
          <button type="button" class="ov-icon-btn dag-block__close" title="Retirer le filtre" @click="clearFilter">
            <v-icon small>mdi-close</v-icon>
          </button>
        </div>
        <StatistiqueReservationParGareTransport
          chart-id="agent-filtre"
          :dataStatistiqueGareTransport="filteredStats"
          :data-statistic-bag-station="filteredBags"
        ></StatistiqueReservationParGareTransport>
      </div>

      <div class="dag-block">
        <div class="dag-block__head">
          <h3 class="dag-block__title">Aujourd'hui</h3>
        </div>
        <StatistiqueReservationParGareTransport
          chart-id="agent-jour"
          :dataStatistiqueGareTransport="dailyStatisticByStation"
          :data-statistic-bag-station="dailyStatisticBags"
        ></StatistiqueReservationParGareTransport>
      </div>

      <div class="dag-block">
        <div class="dag-block__head">
          <h3 class="dag-block__title">Année {{ new Date().getFullYear() }}</h3>
        </div>
        <StatistiqueReservationParGareTransport
          chart-id="agent-annee"
          :dataStatistiqueGareTransport="annualStatisticByStation"
          :data-statistic-bag-station="annualStatisticBags"
        ></StatistiqueReservationParGareTransport>
      </div>
    </section>

    <v-alert class="myalert alert-success" type="success" width="350px" dismissible>{{ successMsg }}</v-alert>
    <v-alert class="myalert alert-error" type="error" width="350px" dismissible>{{ errorMsg }}</v-alert>
  </div>
</template>

<script>
import axios from "axios";
import {
  BASE_URL,
  HEADERS,
  API_STATISTIQUE_RESERVATIONS,
  API_STATISTIQUE_BAGAGES,
} from "@/components/globalConfig/globalConstConfig";
import StatistiqueReservationParGareTransport from "@/modules/statistiques/traders/views/StatistiqueReservationParGareTransport.vue";
import { formatNumber } from "@/modules/statistiques/chartTheme";
import { showErrorMessage } from "../messages/messageProcess";

export default {
  name: "DashboardAgentGare",

  components: {
    StatistiqueReservationParGareTransport,
  },

  data() {
    return {
      successMsg: null,
      errorMsg: null,
      filtering: false,

      caisseStat: null,
      caisseRows: [
        { key: "fondsVeille", label: "Veille" },
        { key: "fondsJour", label: "Aujourd'hui" },
        { key: "fondsAnnuel", label: "Année en cours" },
      ],

      dateFilterList: [
        { title: "Periodique", value: "period" },
        { title: "À une date précise", value: "date" },
      ],
      dateSelected: null,
      // Période réellement affichée (le sélecteur peut changer sans relancer la recherche)
      appliedPeriod: null,
      isFilterApply: false,
      dateDebut: null,
      dateFin: null,
      datePrecise: null,

      dailyStatisticByStation: null,
      annualStatisticByStation: null,
      periodStatisticByStation: null,
      mainlyDateStatisticByStation: null,
      dailyStatisticBags: null,
      annualStatisticBags: null,
      periodStatisticBags: null,
      mainlyDateStatisticBags: null,
    };
  },

  computed: {
    currentDate() {
      return new Date().toLocaleDateString("fr-FR", {
        weekday: "long", day: "numeric", month: "long", year: "numeric",
      });
    },

    canApplyFilter() {
      if (this.dateSelected === "Periodique") return !!(this.dateDebut && this.dateFin);
      if (this.dateSelected === "À une date précise") return !!this.datePrecise;
      return false;
    },

    filterLabel() {
      return this.appliedPeriod === "Periodique"
        ? `Du ${this.formatDate(this.dateDebut)} au ${this.formatDate(this.dateFin)}`
        : `Le ${this.formatDate(this.datePrecise)}`;
    },

    filteredStats() {
      return this.appliedPeriod === "Periodique" ? this.periodStatisticByStation : this.mainlyDateStatisticByStation;
    },

    filteredBags() {
      return this.appliedPeriod === "Periodique" ? this.periodStatisticBags : this.mainlyDateStatisticBags;
    },
  },

  methods: {
    // Valeur d'une période de caisse (null tant que les statistiques ne sont pas chargées)
    caisse(periodKey, field) {
      const period = this.caisseStat && this.caisseStat[periodKey];
      return period ? period[field] : null;
    },

    amount(value) {
      return value == null ? "—" : formatNumber(value);
    },

    showError(message) {
      this.errorMsg = message;
      showErrorMessage();
    },

    // Corps de requête commun : la gare de l'utilisateur et la période éventuelle
    buildPayload({ dateGiven = null, dateDebut = null, dateFin = null } = {}) {
      const gare = this.$store.state.userAuthentified.gareDesignation;
      return {
        data: {
          gareDesignation: gare,
          gareTransportDesignation: gare,
          dateGiven,
          period: { dateDebut, dateFin },
        },
      };
    },

    async post(url, payload) {
      try {
        const response = await axios.post(url, payload, {
          headers: HEADERS(this.$store.state.userAuthentified.token),
        });
        if (response.status == 200 && response.data.status.code == 800) {
          return response.data.item;
        }
        this.showError(response.data && response.data.status ? response.data.status.message : "Erreur lors du chargement des statistiques.");
      } catch (e) {
        this.showError((e && e.message) || "Erreur réseau lors du chargement des statistiques.");
      }
      return null;
    },

    // STATISTIQUES DE CAISSE (VEILLE, JOUR, ANNÉE)
    async getCaisseStatistics() {
      this.caisseStat = await this.post(`${BASE_URL}statistiques/caisse/gare`, {
        data: { gareDesignation: this.$store.state.userAuthentified.gareDesignation },
      });
    },

    // RÉSERVATIONS + BAGAGES D'UNE PÉRIODE ("jour", "annuel", "period", "date")
    async fetchPeriod(period, payload) {
      return Promise.all([
        this.post(API_STATISTIQUE_RESERVATIONS(period, "gare"), payload),
        this.post(API_STATISTIQUE_BAGAGES(period), payload),
      ]);
    },

    async loadDaily() {
      [this.dailyStatisticByStation, this.dailyStatisticBags] = await this.fetchPeriod("jour", this.buildPayload());
    },

    async loadAnnual() {
      [this.annualStatisticByStation, this.annualStatisticBags] = await this.fetchPeriod("annuel", this.buildPayload());
    },

    // APPLIQUER LA RECHERCHE PAR FILTRE (DATES VÉRIFIÉES AVANT L'APPEL)
    async applyFilterReservation() {
      if (!this.canApplyFilter) {
        this.showError(
          this.dateSelected === "Periodique"
            ? "Renseignez la date de début et la date de fin."
            : "Renseignez la date."
        );
        return;
      }
      const isPeriod = this.dateSelected === "Periodique";
      const payload = isPeriod
        ? this.buildPayload({ dateDebut: this.formatDate(this.dateDebut), dateFin: this.formatDate(this.dateFin) })
        : this.buildPayload({ dateGiven: this.formatDate(this.datePrecise) });

      this.filtering = true;
      const [stats, bags] = await this.fetchPeriod(isPeriod ? "period" : "date", payload);
      this.filtering = false;

      if (isPeriod) {
        this.periodStatisticByStation = stats;
        this.periodStatisticBags = bags;
      } else {
        this.mainlyDateStatisticByStation = stats;
        this.mainlyDateStatisticBags = bags;
      }
      if (stats || bags) {
        this.appliedPeriod = this.dateSelected;
        this.isFilterApply = true;
      }
    },

    clearFilter() {
      this.isFilterApply = false;
      this.appliedPeriod = null;
      this.dateSelected = null;
    },

    // FORMAT DE LA DATE (AAAA-MM-JJ -> JJ/MM/AAAA)
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
  },

  mounted() {
    this.getCaisseStatistics();
    this.loadDaily();
    this.loadAnnual();
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/admin/ui";

/* EN-TÊTE */
.dag-head {
  margin-bottom: 28px;
}

.dag-head__date {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: $ov-green;
}

.dag-head__title {
  margin: 4px 0 6px;
  font-size: 24px;
  font-weight: 900;
  letter-spacing: -0.4px;
  color: $ov-navy;
}

.dag-head__meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  font-size: 13px;
  color: $ov-muted;
}

/* SECTIONS */
.dag-section {
  margin-bottom: 40px;
}

.dag-section__head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;

  &--filters {
    flex-wrap: wrap;
    justify-content: space-between;
  }
}

.dag-section__title {
  margin: 0;
  font-size: 16px;
  font-weight: 800;
  color: $ov-navy;
}

.dag-filters {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;

  .ov-select,
  .ov-input {
    width: auto;
    min-width: 170px;
    height: 40px;
    background-color: #ffffff;
  }

  .ov-btn {
    height: 40px;
  }
}

.dag-block {
  margin-bottom: 28px;
}

.dag-block__head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.dag-block__title {
  margin: 0;
  font-size: 14px;
  font-weight: 800;
  color: $ov-muted;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.dag-block__close {
  margin-left: auto;
}

/* TABLEAU COMPARATIF DE CAISSE */
.dag-table-wrap {
  overflow-x: auto;
}

.dag-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;

  th {
    padding: 12px 22px;
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    text-align: left;
    color: $ov-muted;
    background: $ov-soft;
    border-bottom: 1px solid $ov-line;
  }

  td {
    padding: 14px 22px;
    color: $ov-ink;
    border-bottom: 1px solid $ov-line;
  }

  tbody tr:last-child td {
    border-bottom: none;
  }
}

.dag-table__current td {
  background: rgba(21, 158, 114, 0.05);
  font-weight: 700;
}

.dag-num {
  text-align: right !important;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.dag-strong {
  font-weight: 800;
  color: $ov-navy !important;
}

@media (max-width: 760px) {
  .dag-filters {
    width: 100%;

    .ov-select,
    .ov-input,
    .ov-btn {
      flex: 1;
      min-width: 0;
    }
  }
}
</style>
